// Centralised helper to start the custom Markeemix Google OAuth flow.
// Calls the backend /api/auth/google/init endpoint to obtain a properly
// signed Google consent URL (with a redirect_uri that matches the current host)
// and redirects the browser there. Falls back to the direct backend
// /api/auth/google/login route if the init endpoint is unreachable.
//
// Pass { state: "crm" } to route the post-login flow through the CRM branch
// of the callback (creates/logs-in a CRM user and redirects to /crm/auth/callback).

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export async function startGoogleLogin({ state } = {}) {
  const stateQuery = state ? `?state=${encodeURIComponent(state)}` : "";
  try {
    const res = await fetch(`${BACKEND_URL}/api/auth/google/init${stateQuery}`, {
      credentials: "include",
    });
    if (res.ok) {
      const data = await res.json();
      if (data && data.auth_url) {
        window.location.href = data.auth_url;
        return;
      }
    }
  } catch (_err) {
    // ignore – fall through to direct redirect
  }
  // Fallback: hit the backend login route directly (server-side redirect to Google)
  window.location.href = `${BACKEND_URL}/api/auth/google/login${stateQuery}`;
}
